export const UserManagementColumn = [
  {
    title: "SN",
    dataIndex: "slNo",
    key: "slNo",
    fixed: "left",
    className: "index",
  },
  {
    title: "EMPLOYEE NAME",
    dataIndex: "name",
    key: "name",
    fixed: "left",
  },
  {
    title: "EMPLOYEE ID",
    dataIndex: "id",
    key: "id",
  },
  {
    title: "EMAIL ID",
    dataIndex: "email",
    key: "email",
  },
  {
    title: "DEPARTMENT",
    dataIndex: "department",
    key: "department",
  },
  {
    title: "DOMAINS",
    dataIndex: "domains",
    key: "domains",
  },
  {
    title: "ACTIVATION",
    dataIndex: "activation",
    key: "activation",
  },
  {
    title: "",
    dataIndex: "activateAction",
    key: "activateAction",
  },
  {
    title: "",
    dataIndex: "moreOptions",
    key: "moreOptions",
    fixed: "right",
  },
];

export const StateAdminManagementColumn = [
  {
    title: "SN",
    dataIndex: "slNo",
    key: "slNo",
    fixed: "left",
    className: "index",
  },
  {
    title: "MEMBER NAME",
    dataIndex: "name",
    key: "name",
    fixed: "left",
  },

  {
    title: "EMAIL ID",
    dataIndex: "email",
    key: "email",
  },

  {
    title: "ACTIVATION",
    dataIndex: "activation",
    key: "activation",
  },
  {
    title: "",
    dataIndex: "moreOptions",
    key: "moreOptions",
    fixed: "right",
  },
];
